module.exports = __webpack_public_path__ + "static/media/firearms-guardian-small.57e55547.png";